<app-badge ngxClipboard
           [cbContent]="'imports+'+datasource.payload.relationships.data_set_usage_custom_configuration.data.attributes.parameters['mail_hash']+'@adloop.co'"
           (click)="onClipboard()">
  <mat-icon class="material-icons-outlined">mail</mat-icon>
  <span>{{ datasource.payload.relationships.data_set_usage_custom_configuration.data.attributes.import_method }}:</span>
  <span>imports+{{ datasource.payload.relationships.data_set_usage_custom_configuration.data.attributes.parameters['mail_hash'] }}@adloop.co</span>
  <mat-icon class="material-icons-outlined icon-hover">content_copy</mat-icon>
</app-badge>
